import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { Feedback } from './feedback';
import { WebServiceResponse } from '../../global/responses/web-service-response';
import { Logger } from '../../global/logger';
import { ExecuteObservable } from '../../global/execute-observable';

/**
 * This class is a service used to communicate feedback data to the web service.
 */
@Injectable()
export class FeedbackService {

	/** The path to the quote controller. */
	private static readonly FeedbackControllerPath: string = "Feedback/";

	constructor(
		private _HttpClient: HttpClient
	) { }

	/**
	 * Sends new feedback data to the web service.
	 *
	 * @param Value The feedback model from user entry.
	 * @returns A promise which creates feedback in the database.
	 */
	public CreateFeedback(Value: Feedback): Promise<void> {
		let objObservable: Observable<WebServiceResponse>;
		let strUrl: string;
		let intIdentifier: number;

		// Build the request.
		strUrl = environment.WebServiceUrl + FeedbackService.FeedbackControllerPath + "CreateFeedback/";
		objObservable = this._HttpClient.post<WebServiceResponse>(strUrl, Value, { withCredentials: true });

		// Setup logging.
		intIdentifier = Logger.ServiceStartLog("POST", strUrl, Value);
		objObservable = objObservable.pipe(tap(
			(objResponse: WebServiceResponse) => {
				Logger.ServiceEndLog(intIdentifier, "POST", strUrl, objResponse);
			}
		));

		return ExecuteObservable.ExecuteVoid(objObservable, "FeedbackService.CreateFeedback");
	}

}